import { Box, Paper, Skeleton, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { withAlpha } from '../indicacao.utils';

interface KpiCardProps {
	label: string;
	value: string | number;
	hint?: string;
	icon: ReactNode;
	accent: string;
	action?: ReactNode;
}

export function KpiCard({ label, value, hint, icon, accent, action }: KpiCardProps) {
	return (
		<Paper
			elevation={0}
			sx={{
				p: 2.5,
				borderRadius: 3,
				position: 'relative',
				overflow: 'hidden',
				border: '1px solid #f1f5f9',
				height: '100%',
				transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
				'&:hover': {
					transform: 'translateY(-4px)',
					boxShadow: '0 12px 40px rgba(15, 23, 42, 0.08)',
					borderColor: withAlpha(accent, 0.28),
				},
			}}
		>
			<Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5} gap={1}>
				<Typography
					fontSize="0.7rem"
					fontWeight={700}
					textTransform="uppercase"
					letterSpacing={1.4}
					color="#94a3b8"
					lineHeight={1.4}
				>
					{label}
				</Typography>
				<Box
					sx={{
						width: 36,
						height: 36,
						flexShrink: 0,
						borderRadius: 2,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						color: accent,
						bgcolor: withAlpha(accent, 0.12),
					}}
				>
					{icon}
				</Box>
			</Box>
			<Typography
				fontSize={{ xs: '1.45rem', md: '1.7rem' }}
				fontWeight={900}
				letterSpacing={-1.2}
				color={accent}
				lineHeight={1.1}
				noWrap
				title={String(value)}
			>
				{value}
			</Typography>
			{hint && (
				<Typography fontSize="0.75rem" fontWeight={500} color="text.secondary" mt={0.75}>
					{hint}
				</Typography>
			)}
			{action && (
				<Box mt={1.5} mb={0.5}>
					{action}
				</Box>
			)}
			<Box
				sx={{
					position: 'absolute',
					bottom: 0,
					left: 0,
					width: '100%',
					height: 3,
					bgcolor: withAlpha(accent, 0.28),
				}}
			/>
		</Paper>
	);
}

export function KpiCardSkeleton() {
	return (
		<Paper
			elevation={0}
			sx={{ p: 2.5, borderRadius: 3, border: '1px solid #f1f5f9', height: '100%' }}
		>
			<Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
				<Skeleton variant="text" width={110} height={16} />
				<Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: 2 }} />
			</Box>
			<Skeleton variant="text" width={120} height={36} />
			<Skeleton variant="text" width={80} height={16} />
		</Paper>
	);
}
